module.exports = __webpack_public_path__ + "static/media/hexagon-construction.4e2d47c3.svg";